import { render, staticRenderFns } from "./RoamingZones.vue?vue&type=template&id=13945724"
import script from "./RoamingZones.vue?vue&type=script&lang=ts"
export * from "./RoamingZones.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports